import { render, staticRenderFns } from "./SpaceSidebar.vue?vue&type=template&id=7d4ccebc&scoped=true&"
import script from "./SpaceSidebar.vue?vue&type=script&lang=js&"
export * from "./SpaceSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SpaceSidebar.vue?vue&type=style&index=0&id=7d4ccebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4ccebc",
  null
  
)

export default component.exports